import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const ApprovalsPage = lazy(() => import('./ApprovalsPage'));

const routes: RouteObject[] = [
  { path: '/approvals', element: <Guard any={['approval.act']}><ApprovalsPage /></Guard> },
];
export default routes;
